import React from 'react';
import { motion } from 'framer-motion';
import BloodHeader from '../components/BloodHeader';
import CharacterCard from '../components/CharacterCard';
import { characters } from '../data/characters';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <BloodHeader />
      
      <motion.div 
        className="characters-grid"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        {characters.map((character, index) => (
          <CharacterCard 
            key={character.id} 
            character={character} 
            index={index}
          />
        ))}
      </motion.div>
      
      {}
      <div className="blood-stains">
        {[...Array(15)].map((_, i) => (
          <div 
            key={i}
            className="stain"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 200 + 50}px`,
              height: `${Math.random() * 200 + 50}px`,
              background: `rgba(196, 30, 30, ${Math.random() * 0.1})`,
              transform: `rotate(${Math.random() * 360}deg)`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Home;